module.exports = __webpack_public_path__ + "media/images/coupon/member_qrcode-5ad36eab4e3fc001d6781fd510bc5061.svg";